import * as React from "react";
import { TRenderable } from "../SharedTypes";
import { StyleClass } from "./CSS";
import * as styles from "./SharedStyles.css";

function WithGradient({ children }: { children: TRenderable }) {
    const gradientClass = StyleClass(`gradient`, {
        display: `inline-block`,
        position: `relative`,
        ":before": {
            backgroundImage: `linear-gradient( top, rgba( 255, 255, 255, 0 ) 0%, rgba( 255, 255, 255, 1 ) 100% )`,
            content: "\\00a0",
            height: `100%`,
            position: `absolute`,
            width: `100%`,
        },
    });

    return <span className={gradientClass}>{children}</span>;
}

export const sharedStyles = {
    inCenterOfScreen: StyleClass(`inCenterOfScreen`, {
        transform: "translate(50%, 50%)",
        bottom: "50%",
        right: "50%",
        position: "fixed" as "fixed", // Weird typescript issue requires this cast
    }),
    centerText: StyleClass(`centerText`, { textAlign: `center` }),
    table: StyleClass(`table`, {
        fontSize: "0.85em",
    }),
    marginTop1em: StyleClass(`marginTop1em`, { marginTop: `1em` }),
};

export const sharedStylesOld = styles;

export const webkitFilterGlitchFix = {
    WebkitTransform: `translateZ(0)`,
    // WebkitPerspective: 1000, // this causes weird floating icons in Firefox
    WebkitBackfaceVisibility: "hidden" as "hidden",
};

export const Fonts = {
    iMFell: { fontFamily: "IM Fell French Canon SC" },
    shareTechMono: { fontFamily: `'Share Tech Mono', monospace` },
};
